// src/reducers/paymentMethodReducer.js

import { types } from '../types/types';

const initialState = {
    editingPaymentMethod: {
        id: 0,
        name: '',
        ordinal: 0,
        strategyHandler: '',
        referenceUsed: true,
        singlePayment: true,
        realmFk: '',
        status: true
    },
    availablePaymentMethods: [],
};

export const paymentMethodReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.editingPaymentMethodInfo:
            return {
                ...state,
                editingPaymentMethod: action.payload
            };

        case types.clearPaymentMethodInfo:
            return {
                ...state,
                editingPaymentMethod: initialState.editingPaymentMethod
            };

            case types.setAvailablePaymentMethods:
            return {
                ...state,
                availablePaymentMethods: action.payload
            };

        default:
            return state;
    }
};